<template>
  <v-container fluid id="container">
    <v-row align="center" justify="center" id="row">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <div v-if="codigo">
            <v-card class="mx-auto" max-width="374" tile flat>
              <v-img src="@/assets/logo-autolac-laudos.jpeg" height="50%" width="50%" class="mt-3 mx-3"></v-img>
              <v-card-text class="px-5 pt-0">
                <div class="pa-2 pt-0">

                  <div class="mt-4 font-weight-medium title">
                    Olá, {{ nome }}!
                  </div>

                  <div class="mt-0">
                    Você está a um passo de visualizar seu laudo.
                  </div>

                  <div class="mt-2">
                    Por favor, informe a senha fornecida pelo laboratório no protocolo {{ codigo }}.
                  </div>

                  <div>
                    <v-form ref="form">
                      <v-text-field v-model="password" autofocus ref="password"
                        :error-messages="errorMessage" type="password" clearable
                        :disabled="sending" v-on:keydown.enter.prevent="submitLinkNovo()">
                      </v-text-field>
                    </v-form>
                  </div>
                  <p v-if="msgErro" style="color: red">
                    A senha informada não confere com a senha informada no laboratório.
                    <br />
                    Caso você não seja o paciente {{ this.nome }} <a href="https://app.lifesys.com.br/laudos/" style="text-decoration: none">clique aqui</a>
                  </p>

                  <div class="mt-3">
                    É médico?
                    <a style="text-decoration: none" href="https://www.meuconsultorio.com/" target="_blank">Conheça o Meu Consultório!</a>
                  </div>
                </div>
              </v-card-text>

              <v-card-actions class="ma-2">
                <v-row>
                  <v-col col="12" align="right">
                    <v-btn tile dark color="primary" :loading="loading" @click="submitLinkNovo">
                      VISUALIZAR LAUDO
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
          <div v-else>
            <v-card class="mx-auto" max-width="374" tile flat>
              <v-img src="@/assets/logo-autolac-laudos.jpeg" height="50%" width="50%" class="mt-3 mx-3"></v-img>
              <v-card-text class="px-5 pt-0">
                <div class="pa-2 pt-0">

                  <div class="mt-4 font-weight-medium title">
                    Olá, {{ nome }}!
                  </div>

                  <div class="mt-0">
                    Você está a um passo de visualizar seu laudo.
                  </div>

                  <div class="mt-2">
                    Por favor, informe seu protocolo e data de nascimento.
                  </div>

                  <div>
                    <v-form ref="form">
                      <v-text-field v-model="protocolo" autofocus ref="protocolo"
                        :error-messages="errorMessageProtocolo" type="text" clearable placeholder="Protocolo">
                      </v-text-field>
                      <v-text-field v-mask="['##/##/####']" v-model="dataNascimento" 
                        append-icon="event" autofocus ref="dataNascimento" 
                        :error-messages="errorMessageDataNascimento" type="tel" clearable 
                        :disabled="sending" placeholder="DD/MM/AAAA" v-on:keydown.enter.prevent="submitLinkAntigo()">
                      </v-text-field>
                    </v-form>

                  </div>
                  <p v-if="msgErro" style="color: red">
                    O protocolo ou a data de nascimento digitados estão incorretos.
                    <br />
                    Caso você não seja o paciente {{ this.nome }}
                    <a href="https://app.lifesys.com.br/laudos/" style="text-decoration: none">clique aqui</a>
                  </p>

                  <div class="mt-3">
                    É médico?
                    <a style="text-decoration: none" href="https://www.meuconsultorio.com/" target="_blank">Conheça o Meu Consultório!</a>
                  </div>
                </div>
              </v-card-text>

              <v-card-actions class="ma-2">
                <v-row>
                  <v-col col="12" align="right">
                    <v-btn tile dark color="primary" :loading="loading" @click="submitLinkAntigo">
                      VISUALIZAR LAUDO
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Laudos",
  data: () => ({
    nome: "",
    password: null,
    dataNascimento: null,
    protocolo: '',
    dados: '',
    codigo: '',
    loading: false,
    error: false,
    msgErro: "",
    menuData: false,
    errorMessage: "",
    errorMessageProtocolo: "",
    errorMessageDataNascimento: "",
    sending: false,
  }),
  methods: {
    submitLinkNovo() {
      this.loading = true;
      this.msgErro = "";
      this.errorMessage = "";

      if (!this.validations()) {
        return;
      }

      this.validaSenha(this.password);
    },
    submitLinkAntigo(){
      this.loading = true;
      this.msgErro = "";
      this.errorMessage = "";
      this.errorMessageProtocolo = "";
      this.errorMessageDataNascimento = "";

      if(!this.validationsLinkAntigo())
        return;

      let data = this.createDate(this.dataNascimento)

      if (this.errorMessage === 'Data inválida.')
        return;

      let dateNow = new Date();

      if (data > dateNow) {
        this.errorMessageDataNascimento = 'A data informada não pode ser superior à data atual.'
        this.loading = false;
        return;
      }

      this.validaDados(data);

    },
    validations() {
      if (!this.password) {
        this.loading = false;
        this.errorMessage = "Este campo é obrigatório.";
        return false;
      }

      return true;
    },
    validationsLinkAntigo() {
      let retornoValidacao = 'true'

      if (!this.protocolo) {
        this.loading = false;
        this.errorMessageProtocolo = "Este campo é obrigatório.";
        retornoValidacao = 'false';
      }
      if (!this.dataNascimento) {
        this.loading = false;
        this.errorMessageDataNascimento = "Este campo é obrigatório.";
        retornoValidacao = 'false';
      }

      return retornoValidacao;
    },
    isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    },
     createDate() {
      const [day, month, year] = this.dataNascimento.split('/')

        var d = new Date(year, month-1, day);
        
        if (d.getFullYear() != year || d.getMonth() != month-1 || d.getDate() != day) {
          this.errorMessage ='Data inválida.';
          this.loading = false;
          return '';
        }
        
        return d;
    },
    validaSenha(password) {
      let urlValidacao = process.env.VUE_APP_ROOT_URL + "Laudos";

      let dados = {
        codigo: this.codigo,
        senha: password,
      };
      var self = this;

      axios
        .post(urlValidacao, dados)
        .then((res) => {
          window.open(res.data, "_self");
        })
        .catch(() => {
          this.loading = false;
          self.msgErro = `A senha informada não confere com a senha informada no laboratório. <br> Caso você não seja o paciente ${this.nome}, `;
        })
        .finally(() => {});
    },
    validaDados(data){
      let urlValidacao = process.env.VUE_APP_ROOT_URL + "Laudos";

      let dados = {
        dados: this.dados, 
        protocolo: this.protocolo,
        dataNascimento: data,
      };
      var self = this;

      axios
        .post(urlValidacao, dados)
        .then((res) => {
          window.open(res.data, "_self");
        })
        .catch(() => {
          this.loading = false;
          self.msgErro = `O protocolo ou a data de nascimento estão incorretos. <br> Caso você não seja o paciente ${this.nome}, `;
        })
        .finally(() => {});

    },
    async recaptcha() {
      this.$recaptchaLoaded().then(() => {
        this.$recaptcha("homepage").then(() => {
          const recaptcha = this.$recaptchaInstance;

          recaptcha.hideBadge();
        });
      });
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
  },
  created: function () {
    this.nome = this.capitalize(this.$route.query.nome);
    this.codigo = this.capitalize(this.$route.query.codigo);
    this.dados = this.$route.query.dados;
  },
  mounted() {
    this.recaptcha();
  },
};
</script>

<style>
.pagina-enter-active,
.pagina-leave-active {
  transition: opacity 0.8s;
}

.pagina-enter,
.pagina-leave-active {
  opacity: 0;
}

#container,

#row {
  height: 100%;
}

</style>